import React, { useState, useRef, useEffect } from "react";
import WmCards from "../ui-components/wmcards/WmCards";
import WmModals from "../modals/Wm.Modals";
import API_ENDPOINT from "../wm.api.service";
import axios from "axios";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import { useMutation, useQueryClient, } from "react-query";
import { ExclamationIcon } from "@heroicons/react/outline";
import Spinner from "../Components/spinner/Spinner";
import { getSinglePortfolioDetail, updatePublicationData } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
import Moment from "react-moment";
const Cookie = new Cookies();
function Publicationcard({ publicationData }) {
  const queryClient = useQueryClient()
  var token = Cookie.get("wmtoken");
  const [editModal, setEditModal] = React.useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({ title: '', publishers: '', publication_url: '', date_of_publish: '', description: '', media_privacyBool: true, media_privacy: true, mediaSend: '', media: dummy });
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(portfolioData.description)
  }, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteFeild = (e, id) => {
    setIsDeleting(true);
    e.preventDefault();
    var fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("field_name", "PUBLICATION");
    fd.append("field_id", id);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
      data: fd,
    })
      .then(function (response) {
        queryClient.invalidateQueries('publicationData')
        setIsDeleting(false);
        setEditModal(false);
        setIsDeleteModalOpen(false);
      })
      .catch(function (err) {
        setIsDeleting(false);
        alert(err.response.data.message);
      });
  };
  const [deleteModal, setIsDeleteModalOpen] = useState(false);
  const imageDelete = (action) => {
    setPortfolioData((prevData) => {
      prevData.media = null
      prevData.mediaSend = null
      return { ...prevData }
    })
  };
  const fetchSingleData = useMutation((documentId) => getSinglePortfolioDetail('PUBLICATION', documentId), {
    onSuccess: (data) => {
      setPortfolioData(
        { identity: data.identity, title: data.title, publishers: data.publishers, publication_url: data.publication_url, date_of_publish: data.dop, description: data.description, media_privacy: data.media_privacy === '1' ? true : false, mediaSend: data.publication_media && data.publication_media, media: data.publication_media }
      )
      setEditModal(true);
    },
  })
  const updatePublication = useMutation((data) => updatePublicationData(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('publicationData')
      const previousValue = queryClient.getQueriesData('publicationData')
      return previousValue
    },
    onError: (err, previousValue) => {
      queryClient.setQueryData('publicationData', previousValue)
    },
    onSuccess: () => {
      queryClient.invalidateQueries('publicationData')
      setEditModal(false)
    }
  })
  return (
    <React.Fragment>
      {fetchSingleData.isLoading ? "Fetching Data....." :
        <WmCards className="h-full">
          <div className="shadow educationCard space-y-1 relative p-6 cursor-pointer h-full" onClick={(e) => fetchSingleData.mutate(publicationData.identity)}>
            <div className="flex justify-between ">
              <span className="text-base md:text-lg manpro text-gray-700 font-semibold inline-block capitalize" style={{"color":"var(--color-5)"}}>{publicationData.title}</span>
              <span className="text-xs italic text-gray-600 manpro">Published year <Moment format={"YYYY"}>{publicationData.dop}</Moment> </span>
            </div>
            <div className="">
              <span className="text-sm md:text-base text-gray-700 block">{publicationData.publishers}</span>
              <span className="text-sm text-gray-700">{publicationData.description}</span>
            </div>
            <div className="flex justify-between">
              <div>
                <a className="text-sm underline wm-flex-5 italic text-gray-700" href={publicationData.publication_url}>
                  {publicationData.publication_url}
                </a>
              </div>
              {publicationData.media_privacy === "1" ? (
                publicationData.publication_media === null ? (
                  ""
                ) : (
                  <div md={6} className="media_wrapper w-24 h-24 ring-1 ring-gray-300 rounded-md overflow-hidden">
                    <img src={publicationData.publication_media} alt="media" className="w-24 h-24 object-cover" />
                  </div>
                )
              ) : (
                ""
              )}
            </div>
          </div>
        </WmCards>
      }
      <WmModals show={editModal} onHide={() => setEditModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Edit Publication Detail</h5>
        {updatePublication.isError ? <><div><ServerError message={updatePublication.error.response.status} /> <div className="text-center manpro mt-4"><Wmbutton label="Cancel" onClick={() => setEditModal(false)} className="rounded w-20 mr-2" type="button" color="primary" /></div> </div></>
          : <form onSubmit={(e) => { e.preventDefault(); updatePublication.mutate(portfolioData) }}>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Publication Title <Required /></label>
              <input type="text" name="title" placeholder="Publication Title" className="wm_form_input border-bottom border-gray-300" value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }} required />
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Publication/Publisher Name <Required /></label>
              <input type="text" name="publishers" placeholder="Publication/Publisher Name" className="wm_form_input border-bottom border-gray-300" value={portfolioData.publishers} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.publishers = e.target.value; return { ...prevData } }) }} required />
            </div>
            <Row>
              <Col md={12}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Publication Link/URL</label>
                  <input type="url" placeholder="Publication Link/URL" name="publication_url" className="wm_form_input border-bottom border-gray-300" value={portfolioData.publication_url} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.publication_url = e.target.value; return { ...prevData } }) }} />
                  <div>
                    <small className='manpro text-gray-600'>Please type in the correct URL for the Publication http://example.com/</small>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Publication Date <Required /></label>
                  <input type="date" name="date_of_publish" placeholder="Publication Date" className="wm_form_input border-bottom border-gray-300" value={portfolioData.date_of_publish} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.date_of_publish = e.target.value; return { ...prevData } }) }} required />
                </div>
              </Col>
              <Col md={12}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Description</label>
                  <textarea name="description" placeholder="Description" className="wm_form_input border-bottom border-gray-300" value={portfolioData.description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.description = e.target.value; return { ...prevData } }) }} onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150"></textarea>
                  <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/150</small>
                </div>
              </Col>
              <Col md={7}>
                <div className="wm_form_group flex mb-4 items-center">
                  <div className="flex flex-col mr-4">
                    <label className="wm_form_label">Media</label>
                    <input type="file" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg" />
                    <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                      {portfolioData.media && portfolioData.media !== "DELETE" ? <img className="object-cover" src={portfolioData.media} alt="education" /> : <img className="object-cover" src={dummy} alt="education" />}
                    </div>
                  </div>
                  <div>
                    <div><Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right"><HelpIcon /></Tooltip></div>
                    <div> {portfolioData.media && <DeleteForeverIcon className="cursor-pointer" onClick={() => imageDelete("DELETE")} />}</div>
                  </div>
                </div>
              </Col>
              <Col md={5}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Show Media</label>
                  <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })} />
                </div>
              </Col>
            </Row>
            <div className="wm_form_group">
              <Wmbutton label={updatePublication.isLoading ? <CircularProgress className="loader_size_xsm" /> : "Update"} bordered className="rounded w-20 mr-2" type="submit" color="primary-border" />
              <Wmbutton label="Cancel" onClick={() => setEditModal(false)} className="rounded w-20 mr-2" type="button" color="primary" />
              <Wmbutton label="Delete" onClick={(e) => { setIsDeleteModalOpen(true); setEditModal(false); }} className="rounded w-20" type="button" color="danger" />
            </div>
          </form>
        }
      </WmModals>
      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <div className='px-10 py-4'>
          <div>
            <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Publication?</p>
            <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
              <div className='flex space-x-3 p-4'>
                <div>
                  <ExclamationIcon className='w-6 text-red-600' />
                </div>
                <div>
                  <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>Are you sure you want to delete?</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>You can't undo this action.</p>
                </div>
              </div>
            </div>
            <div className='text-center space-x-3 flex justify-center'>
              <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => { setIsDeleteModalOpen(false); setEditModal(true); }}>Cancel</button>
              {isDeleting ? <div className='relative flex items-center justify-center'><Spinner
                className="" width={20} height={20} /></div> : <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={(e) => { deleteFeild(e, publicationData.identity); }}>Delete publication</button>}
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}
export default Publicationcard;
